import * as React from 'react';
import styled from 'styled-components';
import Button from '@mybet/components/Button';

type Props = {
  label: string;
  handleClick(): void;
};

const ButtonRoot = styled(Button)({
  maxWidth: 400,
});

const CampaignButton: React.FC<Props> = ({ label, handleClick }) => {
  return (
    <ButtonRoot onClick={handleClick} variant="primary" size="xLarge" fullWidth>
      {label}
    </ButtonRoot>
  );
};

export default CampaignButton;
